import React from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper/Paper'
import DataComponent from 'EurestoComponents/DataComponents'
import Constants from 'EurestoFonction/Constants'
import Data from 'EurestoClass/Data'


export default class extends React.Component {

  render () {
    const contact = this.props.data
    let libelleCivilite = ''
    if (contact.civilite_id !== undefined && contact.civilite_id !== null && contact.entite === 1) {
      const civiliteFound = Data.get(Constants.module.COMMUN, Constants.donnee.civilite, { id: contact.civilite_id })
      libelleCivilite = civiliteFound.abrege
    }
    return (
      <Paper onClick={this.props.onClick} style={{
        cursor: 'pointer', position: 'relative', height: 90,
        background: 'white'
      }}>
        <Grid container spacing={0} style={{ margin: 0, padding: 10 }}
              justify={'center'}
              alignContent={'center'} alignItems={'flex-start'}>
          <Paper style={{
            left: 2,
            zIndex: 3000,
            position: 'absolute',
            top: 52.5,
            background: 'transparent',
            border: 'none',
            boxShadow: 'none',
            width: 80
          }}>
            <DataComponent
              inline={true}
              disabled={true}
              data={contact.vip}
              actif={(contact.archive_id === null || contact.archive_id === undefined)}
              type={Constants.typeSaisie.Stars}
            />
          </Paper>
          <Grid item style={{ margin: 0, padding: 0, height: 80, minWidth: 80 }}>
            <Paper style={{
              left: 7.5, position: 'absolute', top: -10,
              maxHeight: 80,
              maxWidth: 80,
            }}>
              <DataComponent
                avatarStyle={{
                  borderRadius: 0,
                  maxHeight: 70,
                  maxWidth: 70,
                }}
                disabled={true}
                type={Constants.typeSaisie.Picture}
                defineData={true}
                object={{
                  picture: { id: contact.media_id, lien: contact.media_lien },
                }}/>
            </Paper>
          </Grid>
          <Grid item xs style={{ margin: 0, padding: 0 }}>
            <Grid container spacing={0} style={{ margin: 0, padding: 0 }}
                  justify={'flex-start'} direction={'column'}
                  alignContent={'flex-start'} alignItems={'flex-start'}>
              <Paper style={{
                left: 88, position: 'absolute', top: -10,
                maxHeight: 60, textAlign: 'left', padding:'0px 5px',
                maxWidth: 'calc(100% - 98px)'
              }}>
                <strong className={contact.type === Constants.access.ETABLISSEMENT && contact.licence_active !== 1 && 'EurestoError--text' || ''}>
                  {(libelleCivilite && (libelleCivilite + ' ')) + contact.libelle}
                </strong>
              </Paper>
              <span style={{ textAlign: 'left', marginTop: 2}}>{contact.email}{contact.email && <br style={{lineHeight: .8, height: .8}}/>}
                {contact.ville + (contact.ville && contact.cp && ', ' || '') + (contact.cp > 0 && contact.cp || '')}{(contact.ville || contact.cp) &&
                <br style={{lineHeight: .8}}/> || ''}
                {contact.fixe}{contact.fixe && contact.portable && ' / '}{(contact.portable)}
              </span>
              {contact.qualite_id  && <Paper style={{
                right: -5, position: 'absolute', bottom: -5,
                maxHeight: 60, textAlign: 'left', padding:'0px 5px',
                maxWidth: 'calc(100% - 98px)'
              }}>
                <strong className={contact.type === Constants.access.ETABLISSEMENT && 'EurestoSecondary--text'}>{contact.qualite_id && (Data.get(Constants.module.CRM, Constants.donnee.qualite, { id: contact.qualite_id }).libelle)}
                </strong>
              </Paper> }
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    )
  }

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Card/index.js